var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.74165C0.5 11.1161 4.13814 14.7335 5.74848 16.1204C5.97894 16.3189 6.09556 16.4193 6.2675 16.4703C6.40138 16.5099 6.59843 16.5099 6.73232 16.4703C6.90458 16.4192 7.02038 16.3198 7.25171 16.1206C8.86205 14.7336 12.5 11.1165 12.5 6.74205C12.5 5.08661 11.8679 3.49877 10.7427 2.3282C9.61744 1.15762 8.09141 0.5 6.5001 0.5C4.9088 0.5 3.38259 1.15772 2.25737 2.32829C1.13214 3.49887 0.5 5.08621 0.5 6.74165Z",
    stroke: "#CC4A57",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78574 5.9096C4.78574 6.90548 5.55326 7.7128 6.50003 7.7128C7.44681 7.7128 8.21433 6.90548 8.21433 5.9096C8.21433 4.91372 7.44681 4.1064 6.50003 4.1064C5.55326 4.1064 4.78574 4.91372 4.78574 5.9096Z",
    stroke: "#CC4A57",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.e4b2c3780f3a084be7239ed0dcb35814.svg";
export { ForwardRef as ReactComponent };